<template>
  <div class='document-list'>

    <div class="field-label">
      Документы:
    </div>

    <div class="list-items">

      <template v-if='!isApplicationDocuments && !isOrganizationDocuments && !showAttachScanCopy && !showUserData'>

        <div
          v-for='document in visitorsDocuments'
          :key='document.document.short_name'
          :class="documentKey !== document.document.short_name && documents[document.document.short_name] ? 'clickable' : ''"
          @click='documents[document.document.short_name] ? selectDocument(document.document.short_name, documents[document.document.short_name]) : null'
        >
          {{ document.document.name }}
        </div>

      </template>

      <template v-if='isApplicationDocuments || isOrganizationDocuments'>

        <div
          v-for='document in calculatedApplicationDocuments'
          :key='document.document.short_name'
          :class="documentKey !== document.document.short_name && documents[document.document.short_name] && document.document.short_name !== 'mchd_cades' ? 'clickable' : ''"
          @click="documents[document.document.short_name] && document.document.short_name !== 'mchd_cades' ? selectDocument(document.document.short_name, documents[document.document.short_name]) : null"
        >
          {{ document.document.name }}
        </div>

      </template>

    </div>
  </div>
</template>

<script>
import { TimeTypes } from '@/enums/TimeTypes'
export default {
  props: {
    documents: {
      type: Object
    },

    setFiles: {
      type: Function,
      required: true
    },

    nationalityDocuments: {
      type: Array,
      required: true
    },

    application: {
      type: Object
    },

    visitor: {
      type: Object
    },

    transport: {
      type: Object
    },

    isApplicationAuto: {
      type: Boolean
    },

    isApplicationDocuments: {
      type: Boolean
    },

    isOrganizationDocuments: {
      type: Boolean
    },

    showAttachScanCopy: {
      type: Boolean
    },

    showUserData: {
      type: Boolean
    },

    applicationDocuments: {
      type: Array,
      required: true
    },

    transportDocuments: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      documentKey: null
    }
  },

  computed: {
    visitorsDocuments() {
      if (this.isApplicationAuto) return this.visitor ? this.showableDocuments : this.transportFilesList

      return this.transport ? this.transportFilesList : this.showableDocuments
    },

    showableDocuments() {
      const personal = this.visitor.personal
      const nationality = personal?.nationality_id
      const identification_id = personal?.identification_id
      const residence = personal?.residence
      const application = this.application
      const applicationGroupPurposeId = application.application_group_purpose_id
      const terminalRegionId = application.terminal_region_id

      if (!nationality || !identification_id) {
        return []
      }

      const docs = []
      for (const document of this.nationalityDocuments) {
        if (![null, applicationGroupPurposeId].includes(document.application_group_purpose_id)) {
          continue
        }
        if (![null, nationality].includes(document.nationality_id)) {
          continue
        }
        if (![null, identification_id].includes(document.nationality_identification_id)) {
          continue
        }
        if (![null, terminalRegionId].includes(document.region_id)) {
          continue
        }
        if (document.residence_visible === 0 && Boolean(residence) === true) {
          continue
        }
        if (document.residence_visible === 1 && Boolean(residence) === false) {
          continue
        }

        docs.push(document)
      }

      return docs
    },

    transportFilesList() {
      const application = this.application
      const documents = []
      for (const document of this.transportDocuments) {
        if (![application.terminal_region_id, null].includes(document.region_id)) {
          continue
        }
        if (![this.transport.type, null].includes(document.transport_id)) {
          continue
        }
        if (!this.hasNumber(document.has_number)) {
          continue
        }
        documents.push(document)
      }

      return documents
    },

    calculatedApplicationDocuments() {
      const application = this.application
      const organization = this.application.organization
      const requiresMchd = this.application.require_user_sign && organization.need_attorney

      const documents = []
      for (const document of this.applicationDocuments) {
        if (![application.time_type, TimeTypes.ALL].includes(document.pass_type)) {
          continue
        }
        if (![application.application_group_purpose_id, null].includes(document.purpose_id)) {
          continue
        }
        if (![application.terminal_region_id, null].includes(document.region_id)) {
          continue
        }
        if (![organization.subject_id, null].includes(document.subject_id)) {
          continue
        }
        if (!requiresMchd && document.is_mchd) {
          continue
        }
        documents.push(document)
      }

      const customDocs = []

      if (!this.isOrganizationDocuments) {
        for (const key in this.documents) {
          if (key.includes('pdf')) {
            customDocs.push({
              document: {
                short_name: key,
                name: `Печатная форма ${key[key.length - 1]}`
              }
            })
          }

          if (key === 'scanCopy') {
            customDocs.push({
              document: {
                short_name: key,
                name: 'Скан копия'
              }
            })
          }
        }
      }

      const filteredDocs = documents.filter((doc) => {
        if (this.isOrganizationDocuments) {
          if (this.application.organization.subject_id === 'individual') return doc.document.short_name === 'egrip'

          return doc.document.short_name === 'egrul'
        }

        return doc.document.short_name !== 'egrul' && doc.document.short_name !== 'egrip'
      })

      return [...customDocs, ...filteredDocs]
    }
  },

  watch: {
    documents() {
      let identificationDocument
      if (!this.isApplicationDocuments && !this.isOrganizationDocuments && !this.showAttachScanCopy && !this.showUserData) {

        if (this.isApplicationAuto) {

          if (this.visitor) {
            identificationDocument = this.showableDocuments.find((doc) => doc.nationality_identification_id === this.visitor.personal.identification_id)
          } else {
            identificationDocument = this.transportFilesList[0]
          }

        } else {

          if (this.transport) {
            identificationDocument = this.transportFilesList[0]
          } else {
            identificationDocument = this.showableDocuments.find((doc) => doc.nationality_identification_id === this.visitor.personal.identification_id)
          }

        }
      } else {
        identificationDocument = this.calculatedApplicationDocuments[0]
      }

      if (identificationDocument) {
        this.documentKey = identificationDocument.document.short_name
        this.setFiles(this.documents[this.documentKey])
      }
    }
  },

  methods: {
    hasNumber(has_number) {
      if (has_number === null) {
        return true
      }
      if (has_number === 1) {
        return this.transport.number_missing === 0 || this.transport.number_missing === false
      }
      if (has_number === 0) {
        return this.transport.number_missing === 1 || this.transport.number_missing === true
      }
    },

    selectDocument(key, document) {
      this.documentKey = key
      this.setFiles(document)
    },

    resetDocumentList() {
      this.documentKey = null
    }
  }
}
</script>

<style>
.document-list, .list-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.list-items {
  overflow-y: auto;
}
</style>
